import { Button } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { LogoutOutlined } from '../icons';
import { clearSession, getToken, getUser } from '../stores/session';

/** 登录/注册页共用页头：始终可返回主页；已有会话时可退出登录。 */
export function AuthHeader() {
  const nav = useNavigate();
  const hasSession = Boolean(getToken() && getUser());

  return (
    <header className="auth-header">
      <Link to="/" className="auth-brand">
        <img
          className="auth-logo"
          src="/brand/logo-white.webp"
          alt="成都市第二十中学校"
          width={228}
          height={74}
        />
        <span className="auth-brand-divider" aria-hidden="true" />
        <span className="auth-brand-name">预约平台</span>
      </Link>
      <div className="auth-header-actions">
        {hasSession ? (
          <Button
            type="text"
            className="auth-header-btn"
            icon={<LogoutOutlined />}
            onClick={() => {
              clearSession();
              nav('/login', { replace: true });
            }}
          >
            退出登录
          </Button>
        ) : null}
        <Link to="/" className="auth-back">
          返回主页
        </Link>
      </div>
    </header>
  );
}
